module.exports = __webpack_public_path__ + "roboto-black-webfont.c1811617f93c202ba116.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-black-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-black-webfont.woff
// module chunks = styles